import { useState } from "react";

import CommentApi from "@/api/comment-api";
import ApiErrorComponent from "@/components/common/api-error";
import Button from "@/components/common/input/button";
import Textarea from "@/components/common/input/textarea";
import { logRejection } from "@/helpers";
import ApiError from "@/models/ApiError";
import type { Candidate } from "@/types/candidate";
import type { Comment } from "@/types/comment";

interface CandidateCommentPostBoxProps {
  candidate: Candidate;
  // Handed the comment the API echoed back, which is null on an error.
  postCallback: (comment: Comment | null) => void;
}

export default function CandidateCommentPostBox({
  candidate,
  postCallback,
}: CandidateCommentPostBoxProps) {
  const [comment, setComment] = useState("");
  const [post_error, setPostError] = useState<ApiError | null>(null);

  const _formSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    _onSubmit();
  };

  function _onSubmit() {
    if (!comment) return;
    CommentApi.postCandidateComment({
      candidate_id: candidate.id,
      data: comment,
    })
      .then((result) => {
        if (result.error) {
          console.error(result.error);
          setPostError(result.error);
        } else {
          postCallback(result.data);
          setPostError(null);
          setComment("");
        }
      })
      .catch(logRejection);
  }

  return (
    <div className="w-full">
      <form className="flex w-full flex-col" onSubmit={_formSubmit}>
        <div className="flex flex-col">
          <Textarea
            id="post-box"
            label="Leave a comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={4}
            placeholder="Write your comment here"
            maxLength={1000}
            required
          />
          <span className="-mt-1 mb-4 text-xs text-gray-500">
            {comment.length} / 1000 characters
          </span>
        </div>
        <Button type="submit">Post</Button>
      </form>
      {post_error && <ApiErrorComponent error={post_error} />}
    </div>
  );
}
